import { useEffect, useState } from "react";
import type VisualStoryStore from "./VisualStoryStore";

/**
 * Wo der Leser steht: VOR der Story (Cover), IM Lauf oder HINTER der Story
 * (Credits). Gemeinsam für die Nav-Knöpfe und die Kapitel-Punkte — beide sind
 * vor dem Start aus. beforeStory/afterStory sind Getter am Store; der
 * Scroll-Sync feuert die Abonnenten jedes Bild, gerendert wird nur beim
 * echten Wechsel.
 */
export function useStoryPhase(store: VisualStoryStore): "vor" | "lauf" | "nach" {
    const [phase, setPhase] = useState<"vor" | "lauf" | "nach">("vor");
    useEffect(() => {
        const lies = () => setPhase(store.beforeStory ? "vor" : store.afterStory ? "nach" : "lauf");
        lies();
        const abVor = store.subscribeToBeforeStoryChanges(lies);
        const abNach = store.subscribeToAfterStoryChanges(lies);
        return () => {
            abVor();
            abNach();
        };
    }, [store]);
    return phase;
}
